export default "__VITE_ASSET__Blp1jny2__"